import { z } from "zod";

export const rangeSchema = z
  .object({
    min: z.number().nullable(),
    max: z.number().nullable(),
  })
  .refine(
    (data) => {
      if (data.min === null || data.max === null) return true;
      return data.min <= data.max;
    },
    {
      message: "Minimum kan ikke være større end maximum",
      path: ["min"],
    },
  );

export const requirePhoneSchema = z.object({
  contacts: z.array(
    z.object({
      id: z.string(),
      role: z.object({
        group: z.string().nullable(),
        level: z.string().nullable(),
      }),
      title: z.string().optional().nullable(),
      titleOperator: z.enum(["Equal", "Contains"]).optional(),
    }),
  ),
  requirePhone: z.boolean(),
});

export const addContactSchema = z.object({
  id: z.string().optional(),
  role: z.object({
    group: z.string().nullable(),
    level: z.string().nullable(),
  }),
  title: z.string().optional().nullable(),
});
